import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import axios from '../../../utils/axios';
import { FetchAndroidAppVersionList } from './fetch-android-app-version-list';

export namespace ModifyAndroidAppVersion {
  export type RequestType = {
    versionId: number;
    isCompulsionVersion?: boolean;
  };

  export const useMutate = ({
    onSuccess,
    ...options
  }: UseMutationOptions<AxiosResponse, AxiosError, RequestType> = {}) => {
    const { refetch } = FetchAndroidAppVersionList.useRefetchData();

    const mutation = useMutation(
      ({ versionId, isCompulsionVersion }) => {
        return axios.put(`/android/versions/${versionId}`, {
          isCompulsionVersion: isCompulsionVersion
        });
      },
      {
        onSuccess: (...rest) => {
          refetch();
          onSuccess?.(...rest);
        },
        ...options
      }
    );

    return mutation;
  };
}
